import http from '@/services/axios'

export default {
  listar: () => {
    return http.get('/parceiro/contratacoes?status=NE,AR,OF,AA,CO,AC,AE,AD,TR')
  },
  buscarMotoristaSelecionado: (transportadorId) => {
    return http.get('/parceiro/contratacoes/motorista-selecionado/'+transportadorId)
  },
  estornarDestistencia: (negociacaoId) => {
    return http.delete('/parceiro/contratacoes/estornar-desistencia/'+negociacaoId)
  },
  desistirFrete: (negociacaoId) => {
    return http.post('/parceiro/contratacoes/desistir-frete/'+negociacaoId)
  },
  aceitarContraofertaFrete: (negociacaoId) => {
    return http.post('/parceiro/contratacoes/aceitar-contraoferta-frete/'+negociacaoId)
  },
  adicionarNegociacao(data) {
    return http.post('/parceiro/contratacoes/adicionar-negociacao', data)
  },
  listarTiposVeiculo: () => {
    return http.get('/geral/tipos-veiculo')
  },
  listarTiposCarroceria: () => {
    return http.get('/geral/tipos-carroceria')
  },
  listarMototoristaPorCelular: (celular) => {
    return http.get('/parceiro/contratacoes/motorista/' + celular)
  },
  buscarMototoristaPorCpf: (cpf) => {
    return http.get('/parceiro/contratacao/motorista/cpf/' + cpf)
  },
  consultarPerfilRisco: (data) => {
    return http.post('/parceiro/contratacoes/consultar-perfil-risco', data)
  },
  reprovarMotorista: (negociacaoId) => {
    return http.post(`/parceiro/contratacoes/reprovar-motorista/${negociacaoId}`)
  }
}



// WEBPACK FOOTER //
// ./src/modules/Parceiro/Contratacao/services/index.js